type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

export default function DuplicateIcon({ className, ...props }: Props) {
  return (
    <svg
      {...props}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="8" y="3" width="12" height="15" rx="2" stroke="currentColor" strokeWidth="2" />
      <path d="M5 7V19C5 20.1 5.9 21 7 21H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
